import { z } from 'zod';

/**
 * What the game server says about itself at `GET /version`, before anybody joins: the protocol it
 * speaks (a client of another protocol cannot play, whatever its version) and the oldest app version
 * it still accepts (a release that has to be replaced, for a fix or a store rule, raises it).
 */
export const VersionInfoSchema = z.strictObject({
  protocol: z.number().int(),
  /** `major.minor.patch`; `0.0.0` accepts every client. */
  minClient: z.string().regex(/^\d+\.\d+\.\d+$/),
});
export type VersionInfo = z.infer<typeof VersionInfoSchema>;

/** Orders two `major.minor.patch` versions (anything else counts as `0.0.0`): negative, 0 or positive. */
export function compareVersions(a: string, b: string): number {
  const parts = (v: string): number[] => {
    const m = /^(\d+)\.(\d+)\.(\d+)/.exec(v);
    return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : [0, 0, 0];
  };
  const [x, y] = [parts(a), parts(b)];
  for (let i = 0; i < 3; i++) {
    const d = (x[i] ?? 0) - (y[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
}
